import { render, staticRenderFns } from "./FDropdown.vue?vue&type=template&id=84f2d830"
import script from "./FDropdown.vue?vue&type=script&lang=js"
export * from "./FDropdown.vue?vue&type=script&lang=js"
import style0 from "./FDropdown.vue?vue&type=style&index=0&id=84f2d830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports